<script setup lang="ts">
import {
    ProgressIndicator,
    ProgressRoot,
    type ProgressRootProps
} from 'radix-vue';
import { computed, type HTMLAttributes } from 'vue';

import { cn } from '@/lib/utils';

const props = withDefaults(
    defineProps<
        ProgressRootProps & {
            class?: HTMLAttributes['class'];
            showDestructiveAtEnd?: boolean;
        }
    >(),
    {
        modelValue: 0,
        showDestructiveAtEnd: true
    }
);

const delegatedProps = computed(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { class: _, showDestructiveAtEnd: __, ...delegated } = props;
    return delegated;
});

const indicatorClass = computed(() => {
    if (props.showDestructiveAtEnd && (props.modelValue ?? 0) > 95) {
        return 'bg-destructive';
    }
    return 'bg-foreground';
});
</script>

<template>
    <ProgressRoot
        v-bind="delegatedProps"
        :class="
            cn(
                'relative h-4 w-full overflow-hidden rounded-full bg-secondary',
                props.class
            )
        "
    >
        <ProgressIndicator
            :class="cn('h-full w-full flex-1 transition-all', indicatorClass)"
            :style="`transform: translateX(-${100 - (props.modelValue ?? 0)}%);`"
        />
    </ProgressRoot>
</template>
